"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
_Object$defineProperty(exports, "Credentials", {
  enumerable: true,
  get: function get() {
    return _credentials.default;
  }
});
_Object$defineProperty(exports, "Token", {
  enumerable: true,
  get: function get() {
    return _token.default;
  }
});
_Object$defineProperty(exports, "filterScope", {
  enumerable: true,
  get: function get() {
    return _scope.filterScope;
  }
});
_Object$defineProperty(exports, "grantErrors", {
  enumerable: true,
  get: function get() {
    return _grantErrors.default;
  }
});
_Object$defineProperty(exports, "sortScope", {
  enumerable: true,
  get: function get() {
    return _scope.sortScope;
  }
});
var _webexCore = require("../../webex-core");
var _credentials = _interopRequireDefault(require("./credentials"));
var _scope = require("./scope");
var _token = _interopRequireDefault(require("./token"));
var _grantErrors = _interopRequireDefault(require("./grant-errors"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerPlugin)('credentials', _credentials.default, {
  proxies: ['canAuthorize', 'canRefresh']
});
//# sourceMappingURL=index.js.map
